import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-moment";
import moment from "moment";
import { converteParaHorarioLocal } from "../utils/utils";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend
);

export default function GraficoVento({ dataEstacao, date }) {
    const options = {
        radius: 1, // desabilitar pontos
        locale: 'pt-br',
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                type: "time",
                time: {
                    unit: "hour",
                    displayFormats: {
                        hour: "HH:00",
                    },
                },
                min: moment(new Date(date.year, date.month - 1, date.day, 5, 0, 0)),
                max: moment(new Date(date.year, date.month - 1, date.day, 20, 0, 0)),
            },
            y: {
                title: {
                    display: true,
                    text: "Vento (m/s)",
                },
            },
        },
        tension: 0.4,
    };

    const data = {
        labels: dataEstacao?.map((g) => converteParaHorarioLocal(g.data)),
        datasets: [
            {
                label: "Vento",
                data: dataEstacao?.map((g) => g.vento),
                borderColor: "rgb(153, 0, 204)",
                backgroundColor: "rgb(153, 0, 204, 0.5)",
            },
        ],
    };

    return <Line options={options} data={data} />;
}
